/** 搜索筛选只保留 PRD 要求的 72H达、7日达；-1 是空标签，不作为筛选项展示。 */
export const DELIVERY_FILTER_OPTIONS = [
  { code: 2, label: '72H达' },
  { code: 4, label: '7日达' },
] as const;

export type DeliveryFilterOption = (typeof DELIVERY_FILTER_OPTIONS)[number];

export function resolveDeliveryFilterOptions(value: unknown): DeliveryFilterOption[] {
  if (!Array.isArray(value)) return [];
  return DELIVERY_FILTER_OPTIONS.filter(option => value.includes(option.code));
}

export function normalizeDeliveryFilters(value: unknown): number[] {
  if (!Array.isArray(value)) return [];
  return DELIVERY_FILTER_OPTIONS.map(option => option.code).filter(code => value.includes(code));
}

/** 时效开关独立增删，保留其他已选项；同时选择由后端 IN 条件取并集。 */
export function toggleDeliveryFilter(value: unknown, code: number, checked: boolean): number[] {
  const selected = normalizeDeliveryFilters(value).filter(item => item !== code);
  return normalizeDeliveryFilters(checked ? [...selected, code] : selected);
}
